let deliveryLoginSignInInFlight = false;

export const setDeliveryLoginSignInInFlight = (inFlight: boolean) => {
  deliveryLoginSignInInFlight = inFlight;
};

export const isDeliveryLoginSignInInFlight = () => deliveryLoginSignInInFlight;

export const endDeliveryLoginSignInInFlight = () => {
  queueMicrotask(() => {
    deliveryLoginSignInInFlight = false;
  });
};
